import axios from "axios";

// Centralised axios client that:
// - prefixes /api,
// - sends httpOnly cookies (withCredentials: true),
// - additionally sends a Bearer token (fallback when cookies are blocked
//   third-party, e.g. iOS Safari in some embeds).
const baseURL = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

const LS_TOKEN = "eq_access_token";

export const setAccessToken = (token) => {
  if (token) localStorage.setItem(LS_TOKEN, token);
  else localStorage.removeItem(LS_TOKEN);
};
export const getAccessToken = () => localStorage.getItem(LS_TOKEN);

api.interceptors.request.use((cfg) => {
  const t = getAccessToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// FastAPI 422 returns an array of {msg,...} — render-safe string converter.
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
